import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

export interface ITheme {
  width?: number;
  margin?: number;
  fontSize?: number;
  textAlign?: string;
}

const NoDocPlaceholder = () => {
  return (
    <Alert
      data-selector="no-documents-placeholder"
      status="success"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      gap={4}
      px={8}
      py={12}
      mt={8}
      borderRadius="lg"
    >
      <AlertIcon boxSize="40px" mr={0} />

      <AlertDescription>No documents required.</AlertDescription>
    </Alert>
  );
};

export default NoDocPlaceholder;
